import { CartItemViewModel } from '@/types/api'

import { useAppCart } from '@/app/_utils/use-app-cart'

interface ReturnType {
    isLoading: boolean
    productInCart: CartItemViewModel | null
}

export function useGetProductInCart(atpId: string): ReturnType {
    const { cart, isLoading } = useAppCart()

    if (!atpId) return { productInCart: null, isLoading: false }
    if (!isLoading && !cart?.items?.length) return { productInCart: null, isLoading: false }

    const productInCart = cart?.items?.find((item) => !item.gift && `${item.atpId}` === atpId) || null

    return { productInCart, isLoading }
}
